import { IonImg, IonButton, IonIcon } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { search } from 'ionicons/icons';
import './Step4.css';
import pasargad from '../../../assets/images/pasargad.png';
import saman from '../../../assets/images/saman.png';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    bookResult: any
}
const Step4 = (props: Props) => {
    const history = useHistory();
    const goBack = () => {
        history.replace('/home');
    }
    return (
        <div className="hotel-reservation-step4">
            {Object.keys(props.bookResult).length !== 0 ?
                <>
                    {!props.bookResult.hasOwnProperty('errors') ?
                        <>
                            <h5>بر روی درگاه مورد نظر خود کلیک کنید.</h5>
                            {Object.entries(props.bookResult.hotelReservations.hotelReservation[0].uniqueID[0].tpaextensions.any[0]).map((item: any, index: number) =>
                                <a href={item[1]} target="_blank" rel="noreferrer" key={"index" + index} className="payment-gateway" onClick={goBack}>
                                    <div>
                                        {item[0] === 'pasargad' ?
                                            <IonImg src={pasargad} />
                                            : item[0] === 'saman' ?
                                                <IonImg src={saman} />
                                                :
                                                null
                                        }
                                        <span>
                                            {item[0] === 'pasargad' ?
                                                'درگاه بانک پاسارگاد'
                                                : item[0] === 'saman' ?
                                                    'درگاه بانک سامان'
                                                    :
                                                    null
                                            }
                                        </span>
                                    </div>
                                </a>
                            )}
                        </>
                        :
                        <>
                            {props.bookResult.errors.error.map((error: any, index: number) =>
                                <div className="box-error ion-margin-top" key={'hotel_book_result_error_key_' + index}>
                                    <IonImg src={warningSign} />
                                    <p>{error.value}</p>
                                </div>
                            )}
                            <IonButton color="warning" expand="block" onClick={goBack}>
                                تغییر جستجو
                                <IonIcon icon={search} className="ion-margin-start" />
                            </IonButton>
                        </>
                    }
                </>
                :
                <>
                    <div className="box-error">
                        <IonImg src={warningSign} />
                        <p>اطلاعاتی یافت نشد!</p>
                    </div>
                    <IonButton color="warning" expand="block" onClick={goBack}>
                        تغییر جستجو
                        <IonIcon icon={search} className="ion-margin-start" />
                    </IonButton>
                </>
            }
        </div>
    );
};
export default Step4;